import { t } from 'i18next';
import { toast } from 'react-toastify';
import { ApiParams } from '~/providers';

export function checkDamCanProgramming(dam: ApiParams['/dam/set-dam-info']): boolean {
  if (!dam.groups || dam.groups.length === 0) {
    toast.warn(t('precisaMaquinaAutomatizada'));
    return false;
  }

  return true;
}
